var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: [_vm.listClass] },
    _vm._l(_vm.menu, function(item) {
      return _c(
        "li",
        {
          key: item.id,
          class: [
            _vm.itemClass,
            item.children.length > 0 ? _vm.itemClass + "--has-submenu" : null,
            _vm.open == item ? _vm.itemClass + "--submenu-open" : null
          ]
        },
        [
          item.children.length == 0
            ? _c(
                "link-component",
                {
                  class: [_vm.linkClass],
                  attrs: {
                    link: item.url,
                    title: item.label,
                    "active-class": _vm.linkClass + "--active",
                    "exact-active-class": _vm.linkClass + "--exact-active"
                  }
                },
                [_vm._v("\n            " + _vm._s(item.label) + "\n        ")]
              )
            : _c(
                "a",
                {
                  class: [_vm.linkClass, _vm.linkClass + "--submenu-trigger"],
                  attrs: { href: "javascript:;", title: item.label },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.openMenu(item)
                    }
                  }
                },
                [_vm._v("\n            " + _vm._s(item.label) + "\n        ")]
              ),
          _vm._v(" "),
          item.children.length > 0
            ? _c(
                "ul",
                { class: [_vm.submenuClass] },
                _vm._l(item.children, function(subitem) {
                  return _c(
                    "li",
                    { key: subitem.id, class: [_vm.itemClass] },
                    [
                      _c(
                        "link-component",
                        {
                          class: [_vm.linkClass],
                          attrs: {
                            link:
                              subitem.localized.external_url ||
                              "/" + subitem.localized.uri.slug,
                            title: subitem.localized.title,
                            "active-class": _vm.linkClass + "--active",
                            "exact-active-class":
                              _vm.linkClass + "--exact-active"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(subitem.localized.title) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfee6974", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfee6974","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/components/package/RF/CMS/Menu.vue
// module id = 235
// module chunks = 17